import { FetchAPI } from './auth-service';
class NotifyDataService {
    constructor () {
        // we only need one of these
        if (!NotifyDataService.instance) {
            NotifyDataService.instance = this;
        }

        this.HEALTH_POLL_INTERVAL = 11000;

        this.getNotifications = () => {
            return FetchAPI({
                method: 'GET',
                url: (process.env.BRICATA_APPLIANCE_TYPE === 'mc2' ? 'mc2/system/health/' : 'system/health'),
            }).then(res => {
                return res || { object: {} };
            });
        };

        return NotifyDataService.instance;
    }
}

const NotifyService = new NotifyDataService();

export default NotifyService;
